import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import MarkdownEditorController from "./controllers/markdown_editor_controller"
import ImageUploadController from "./controllers/image_upload_controller"
import SeoKeywordsController from "./controllers/seo_keywords_controller"

const application = Application.start()
application.register("markdown-editor", MarkdownEditorController)
application.register("image-upload", ImageUploadController)
application.register("seo-keywords", SeoKeywordsController)
